import React from "react";
import { AlertTriangle, Info, Loader2, SearchX } from "lucide-react";

export function Alert({ tone = "error", title, children, action }) {
  const tones = {
    error: "border-opposed/25 bg-opposed-soft text-opposed",
    warning: "border-pending/25 bg-pending-soft text-pending",
    info: "border-ink-200 bg-ink-100 text-ink-700",
  };
  const Icon = tone === "info" ? Info : AlertTriangle;

  return (
    <div className={`flex items-start gap-3 rounded border px-4 py-3 text-sm ${tones[tone]}`}>
      <Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <div className="min-w-0 flex-1">
        {title && <p className="font-semibold">{title}</p>}
        <div className={title ? "mt-0.5 opacity-90" : ""}>{children}</div>
      </div>
      {action}
    </div>
  );
}

/**
 * Loading state for the search itself. `note` carries the retry message, so
 * a slow request explains itself instead of looking frozen.
 */
export function SearchingState({ note }) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 py-24 text-center"
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-7 w-7 animate-spin text-ink-500" aria-hidden="true" />
      <p className="text-sm text-ink-600">Searching the register and scoring conflicts</p>
      {note && <p className="text-xs text-pending">{note}</p>}
    </div>
  );
}

export function EmptyState({ title, children, action }) {
  return (
    <div className="rounded-soft border border-dashed border-ink-200 bg-white px-6 py-16 text-center">
      <SearchX className="mx-auto mb-3 h-8 w-8 text-ink-300" aria-hidden="true" />
      <p className="font-display text-lg text-ink-900">{title}</p>
      {children && <p className="mx-auto mt-1.5 max-w-reading text-sm text-ink-600">{children}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
